<template>
  <div class="grid grid-rows-[auto_1fr] items-center h-full text-my-gray">
    <ThreadsNav show-back class="w-full">
      <template #center>
        <div class="text-xl font-semibold">
          {{ $t(`Payment.withdrawRecord`) }}
        </div>
      </template>
    </ThreadsNav>
    <ThreadList
      ref="promptListRef"
      :on-scroll-load="fetchList"
      :on-pull-load="() => fetchList(true)"
      class="px-2 w-full"
    >
      <div v-for="item in list" class="mb-1">
        <div
          class="grid grid-cols-[1fr_auto] grid-rows-[auto_auto] items-center gap-1 bg-my-dark p-2 rounded"
        >
          <h2 class="text-white" @click="clickCopy(item.paypalBatchId)">
            ID: {{ item.paypalBatchId }}
          </h2>

          <div class="text-primary text-base text-end row-span-3">
            <span>-${{ item.amount.toFixed(2) }}</span>
            <span class="text-my-gray block text-xs">
              {{
                t(`Payment.containPaypalFee`, {
                  amount: item.feeAmount.toFixed(2),
                })
              }}
            </span>
          </div>
          <div class="flex items-center">
            <span>
              {{ $t(`story.status`) }}:
              <b :class="StatusStyleMap[item.status]">
                {{ $t(`Payment.withdrawStatus.${item.status}`) }}
              </b>
            </span>
          </div>
          <div>{{ $t(`SidebarNavi.account`) }}: {{ item.receiver }}</div>
          <div>
            {{ moment(item.dtCreate).format(`YYYY-MM-DD HH:mm:ss`) }}
          </div>
        </div>
      </div>
    </ThreadList>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from "vue";
import { ApiGetWithdrawalPage } from "@/apis/payment";
import moment from "moment-timezone";
import { ThreadListInstance } from "@/components/mobile/ThreadList.vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { copyToClipboard } from "@/modules/common";
import { showSuccessToast } from "vant";

const promptListRef = ref<null | ThreadListInstance>(null);
const list = ref<Withdrawal[]>([]);
const PER_PAGE = 12;

const { t } = useI18n();
const route = useRoute();
const StatusStyleMap = {
  1: "",
  2: "text-success",
  3: "text-error",
};

const fetchList = async (isReload = false) => {
  // ApiList
  if (isReload) {
    list.value = [];
    promptListRef.value?.resetScrollLoadingState();
    return true;
  }
  const page = Math.floor(list.value.length / PER_PAGE) + 1;
  const {
    page: { data },
  } = await ApiGetWithdrawalPage({
    pagination: {
      page,
      perPage: PER_PAGE,
    },
    sort: {
      field: "dtCreate",
      order: "desc",
    },
  });
  list.value = [...list.value, ...data];
  return data.length === PER_PAGE;
};

const clickCopy = (id: string) => {
  copyToClipboard(id);
  showSuccessToast(t(`Message.copySuccessful`));
};

onMounted(async () => {});
</script>
